import { RESET_STATE } from 'store/global/actions';

import { COMPANY_DOMAINS_ACTION_TYPE } from '../actions';

const initialState = {};

const domainsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_DOMAINS_ACTION_TYPE.GET_DOMAINS:
      return payload;

    case COMPANY_DOMAINS_ACTION_TYPE.ADD_DOMAINS:
      return { ...state, [payload.companyId]: (state[payload.companyId] || []).concat(payload) };

    case COMPANY_DOMAINS_ACTION_TYPE.REMOVE_DOMAINS:
      return {
        ...state,
        [payload.companyId]: state[payload.companyId]?.filter(
          domain => payload.domainName !== domain.domainName,
        ),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default domainsReducer;
